import { PaymentMethodAccountTypes } from '@user/store/payments/typings'

export type PaymentCallbackResponse = CallbackSuccess | CallbackError

type CallbackError = {
  Error: string
}

type CallbackSuccess = {
  AccountType: PaymentMethodAccountTypes
  AccountUpdater: any
  AutoBilledServices: any[]
  BankAccount: any
  BillToID: number
  Branch: string
  BranchID: number
  CardID: number
  CreditCard: {
    AccountNumber: string
    CardToken: string
    CreditCardType: string
    ExpirationDate: string
    NameOnCard: string
  }
  IsPrimary: boolean
}

export const isPaymentCallbackError = (
  entity: unknown,
): entity is CallbackError => {
  const e = entity as CallbackError
  return !!e.Error
}

export const isPaymentCallbackSuccess = (
  entity: unknown,
): entity is CallbackSuccess => {
  const e = entity as CallbackSuccess
  return !!e.CardID
}
